<template>
  <b-row>
    <StepperCol :step="6" />
    <b-col cols="10" md="11" class="pb-4">
      <h5
        class="h3 font-weight-normal mb-4"
        :class="collapsed ? '' : 'text-muted'"
      >
        専用コンセントが近くにありますか？
      </h5>
      <b-collapse v-model="shrinking" class="d-md-none">
        <b-button
          variant="outline-warning"
          size="lg"
          class="btn-gd text-left position-relative py-2"
          block
          @click="shrinking = false"
        >
          <span class="h4 m-0">{{
            a0Selected
              ? "専用コンセントが近くにある"
              : "専用コンセントが近くにない"
          }}</span>
          <div class="d-block text-muted">
            {{ a0Selected ? "¥0-" : "¥27,500~" }}
          </div>
          <div class="accessory-shrinking">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 12 12"
            >
              <polyline
                fill="none"
                stroke="#FD9000"
                stroke-width="2"
                points="0,6 6,11 12,6"
              />
            </svg>
          </div>
        </b-button>
      </b-collapse>
      <b-collapse v-model="isCollapsed">
        <b-row>
          <b-col cols="12" md="6" lg="5" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="a0Selected ? 'selected' : ''"
              @click="buttonClicked(0)"
            >
              <h6 class="h4 pt-2 px-3">専用コンセントが近くにある</h6>
              <b-row no-gutters>
                <b-col
                  cols="4"
                  class="pl-3 pt-3 d-flex flex-column justify-content-between"
                >
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">0-</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="8" class="d-flex align-items-end">
                  <b-img
                    :src="require('@/assets/images/q-5-1@2x.png')"
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>
          <b-col cols="12" md="6" lg="5" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="a1Selected ? 'selected' : ''"
              @click="buttonClicked(1)"
            >
              <h6 class="h4 pt-2 px-3">専用コンセントが近くにない</h6>
              <b-row no-gutters>
                <b-col
                  cols="5"
                  class="pl-3 pt-3 d-flex flex-column justify-content-between"
                >
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">27,500~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col
                  cols="7"
                  class="d-flex align-items-end pr-2 pb-3 position-relative"
                >
                  <b-img
                    :src="require('@/assets/images/q-5-2@2x.png')"
                    fluid
                  ></b-img>
                  <p
                    class="position-absolute text-danger mb-0"
                    style="bottom: 0px; left: 0"
                  >
                    <b-img :src="require('@/assets/images/cross.svg')"></b-img
                    >延長コード<br />
                    <b-img :src="require('@/assets/images/cross.svg')"></b-img
                    >床面付近のコンセント
                  </p>
                </b-col>
              </b-row>
            </b-button>
          </b-col>
        </b-row>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import StepperCol from "../StepperCol";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    StepperCol,
  },
  data() {
    return {
      collapsed: false,
      shrinking: false,
      a0Selected: false,
      a1Selected: false,
    };
  },
  watch: {
    currentStep(val, old) { // eslint-disable-line
    },
    maxStep(val, old) { // eslint-disable-line
      if (val >= 6) {
        this.collapsed = true;
      }
    },
  },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
    }),
    isCollapsed: {
      get() {
        if (this.shrinking) {
          if (window.innerWidth < 576) {
            return false;
          } else {
            return true;
          }
        } else {
          return this.collapsed;
        }
      },
      set(value) { // eslint-disable-line
      },
    },
  },
  methods: {
    reset() {
      this.shrinking = false;
      this.collapsed = false;
      this.a0Selected = false;
      this.a1Selected = false;
    },
    ...mapActions({
      doUpdateStep: "doUpdateStep",
      doSaveAnswer: "doSaveAnswer",
    }),
    buttonClicked(value) {
      if (value == 0) {
        this.a0Selected = true;
        this.a1Selected = false;
      } else {
        this.a0Selected = false;
        this.a1Selected = true;
      }
      this.doSaveAnswer({ keyword: 'has_socket', answer: value });
      if (value == 0) {
        this.doUpdateStep(7);
      } else {
        // step6を飛ばす
        this.doSaveAnswer({ keyword: 'socket_type', answer: 0 });
        this.doUpdateStep(8);
      }
      this.shrinking = true;
    },
  },
};
</script>